import React from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import Availability from '../../Pages/Availability/availability'
import WaitingList from '../../Pages/WaitingList/waitingList'
import Calendar from '../../Pages/Appointment/calendar'
import AppointmentList from '../../Pages/Appointment/appointmentList'
import AppointmentView from '../../Pages/Appointment/appointmentView'

import ClientList from '../../Pages/Client/clientList'
import ClientView from '../../Pages/Client/clientView'
import TeamList from '../../Pages/Team/teamList'
import TeamProfile from '../../Pages/Team/teamProfile'
import ServiceList from '../../Pages/Service/serviceList'
import ServiceCategory from '../../Pages/Service/serviceCategory'
import ServiceDuration from '../../Pages/Service/serviceDuration'
import OfferList from '../../Pages/Offer/offerList'
import ReadNotification from '../../Pages/Notifications/notification'
import Setting from '../../Pages/Setting/setting'
import Policies from '../../Pages/Setting/Policy/policies'
import ChangePin from '../../Pages/Setting/changePin'
import HelpSupport from '../../Pages/Setting/Ticket/ticketList'
import SettingNotification from '../../Pages/Setting/settingNotification'
import BookingPolices from '../../Pages/Setting/Policy/bookingPolices'
import CancellationPolicies from '../../Pages/Setting/Policy/cancellattionPolicy'
import Faq from '../../Pages/Setting/faq'
import Profile from '../../Pages/Profile/profile'
import Dashboard from '../../Pages/Dashboard/dashboard'
import ReschedulingPolicy from '../../Pages/Setting/Policy/reschedulingPolicy'
import RefundPolicy from '../../Pages/Setting/Policy/refundPolicy'
import StaffCalendar from '../../Pages/AppointmentStaff/calendar';
import StaffAppointmentList from '../../Pages/AppointmentStaff/appointmentList';

import InsightList from '../../Pages/Insight/insightList'
import BookingDetails from '../../Pages/Insight/bookingDetails'
import ClientReport from '../../Pages/Insight/clientReport'
import TeamReport from '../../Pages/Insight/teamReport';
import DemoGraphics from '../../Pages/Insight/demoGraphics'
import ServiceReport from '../../Pages/Insight/serviceReport'
import FeedBack from '../../Pages/Insight/feedBack'
import RushHours from '../../Pages/Insight/rushHours'
import PageNoFound from '../Error/pageNoFound'
import Chat from '../../Pages/Chat/chat'
import ProfileTeam from '../../Pages/Profile/teamProfile';
import MyPlan from '../../Pages/Setting/My Plan/myPlan'
import MyPlanHistory from '../../Pages/Setting/My Plan/myPlanHistory'
import MyCard from '../../Pages/Setting/My Plan/myCard'
import ChatMobile from '../../Pages/Chat/chatMobile'
import AddTeam from '../../Pages/Team/addTeam'
import Reward from '../../Pages/Reward/reward'
import ComboView from '../../Pages/Appointment/comboView'
import ComboReport from '../../Pages/Insight/comboReport'
import ComboPacakgeReport from '../../Pages/Insight/comboPacakgeReport'

import Contact from '../../Pages/Campaign/Contact'
import AddContact from '../../Pages/Campaign/Contact/addContact'
import MainPage from '../../Pages/Campaign/MainPage'
import Group from '../../Pages/Campaign/Group'
import AddGroup from '../../Pages/Campaign/Group/addGroup'
import Campaign from '../../Pages/Campaign/Campaign'
import AddCampaign from '../../Pages/Campaign/Campaign/addCampaign'
import EmailCampaign from '../../Pages/Campaign/Campaign/emailCampaign'
import PromotionalAddon from '../../Pages/Setting/promotionalAddon/promotionalAddon'
import PromotionalMessage from '../../Pages/Insight/promotionalMessage/promotionalMessage'
import Gst from '../../Pages/Setting/Gst'
import InventoryManagement from '../../Pages/inventoryManagement/InventoryManagement'
import AddVendor from '../../Pages/inventoryManagement/AddVendor'
import UpdateVendor from '../../Pages/inventoryManagement/UpdateVendor'
import AddInventory from '../../Pages/inventoryManagement/AddInventory'
import UpdateInventory from '../../Pages/inventoryManagement/UpdateInventory'
import ChatAi from '../../Pages/ChatAi/chatAi'
import InvoiceGenerate from '../../Pages/invoice-generate/InvoiceGenerate'
import BillInvoiceList from '../../Pages/invoice-generate/BillInvoiceList'
import Commission from '../../Pages/Insight/commission-structure/Commission'
import CommissionStructure from '../../Pages/Setting/CommissionStructure/CommissionStructure'
import AddCommissionStructure from '../../Pages/Setting/CommissionStructure/AddCommissionStructure'
import UpdateCommissionStructure from '../../Pages/Setting/CommissionStructure/UpdateCommissionStructure'
import ByStructureDetails from '../../Pages/Insight/commission-structure/ByStructureDetails'
import ByTeamMemberDetails from '../../Pages/Insight/commission-structure/ByTeamMemberDetails'
import BroupCommissionDetails from '../../Pages/Insight/commission-structure/BroupCommissionDetails'

// import MultipleLogin from '../../Pages/Multiple Login/multipleLogin'


const Main = () => {
  const userData = JSON.parse(localStorage.getItem('userData'))

  return (
    <div className='dashboard_main'>
      <Routes>
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="availability" element={<Availability />} />
        <Route path="appointmentList/calendar" element={userData?.roleTitle === 'STAFF' ? <StaffCalendar /> : <Calendar />} />
        <Route path="appointmentList/:type/:statusTyp/calendar" element={userData?.roleTitle === 'STAFF' ? <StaffCalendar /> : <Calendar />} />
        <Route path="appointmentList" element={userData?.roleTitle === 'STAFF' ? <StaffAppointmentList /> : <AppointmentList />} />
        <Route path="appointmentList/:type/:statusType" element={userData?.roleTitle === 'STAFF' ? <StaffAppointmentList /> : <AppointmentList />} />
        {/* <Route path="appointmentList/calendar" element={ <Calendar />} />
        <Route path="appointmentList" element={<AppointmentList />} /> */}
        <Route path="appointmentList/appointmentView/:id" element={<AppointmentView />} />
        <Route path="appointmentList/:type/:statusType/appointmentView/:id" element={<AppointmentView />} />
        <Route path="appointmentList/:type/:statusType/combo-view/:id" element={<ComboView />} />
        <Route path="appointmentList/combo-view/:id" element={<ComboView />} />

        <Route path="waitingList" element={<WaitingList />} />
        <Route path="client" element={<ClientList />} />
        <Route path="inventoryManagement" element={<InventoryManagement />} />
        <Route path="inventoryManagement/add-vendor" element={<AddVendor />} />
        <Route path="inventoryManagement/update-vendor/:id" element={<UpdateVendor />} />
        <Route path="inventoryManagement/add-inventory" element={<AddInventory />} />
        <Route path="inventoryManagement/update-inventory/:id" element={<UpdateInventory />} />
        <Route path="client/clientView/:id" element={<ClientView />} />

        <Route path="team" element={<TeamList />} />
        <Route path="team/teamProfile/:staffId" element={<TeamProfile />} />
        <Route path="teamProfile/:staffId" element={<TeamProfile />} />
        <Route path="team/teamProfile/:staffId/:type" element={<TeamProfile />} />
        <Route path="team/add-team" element={<AddTeam />} />

        <Route path="service" element={<ServiceCategory />} />
        <Route path="service/serviceList/:categoryId" element={<ServiceList />} />
        <Route path="service/serviceDuration" element={<ServiceDuration />} />

        <Route path="offer" element={<OfferList />} />
        {
          userData?.planDetails?.addons?.length && userData?.planDetails?.addons?.find((item) => item.keyName === "Rewards"||item.keyName === 'rewards' )?.keyValue ?
        <Route path="reward" element={<Reward />} />
        :null
        }
        

        <Route path="notification" element={<ReadNotification />} />
        <Route path="bill-invoice" element={<BillInvoiceList />} />
        <Route path="bill-invoice/bill-generate" element={<InvoiceGenerate />} />
        {/* <Route path="campaign" element={<Campaign />} /> */}
        <Route path='campaign' element={<MainPage />}>
          <Route index element={<Navigate to="contact" replace />} />
          <Route  path='contact' element={<Contact />} />
          <Route path='contact/add-contact' element={<AddContact />} />
          <Route path='contact/edit-contact/:id' element={<AddContact />} />
          <Route path='group' element={<Group />} />
          <Route path='group/add-group' element={<AddGroup />} />
          <Route path='group/edit-group/:id' element={<AddGroup />} />
          <Route path='campaign' element={<Campaign />} />
          <Route path='campaign/add-campaign' element={<AddCampaign />} />
          <Route path='campaign/edit-campaign/:id' element={<AddCampaign />} />
          <Route path='campaign/email-campaign/:id' element={<EmailCampaign />} />
        </Route>

        <Route path="setting" element={<Setting />} />
        <Route path="setting/policies" element={<Policies />} />
        <Route path="setting/changePin" element={<ChangePin />} />
        <Route path="setting/gst" element={<Gst />} />
        <Route path="setting/helpSupport" element={<HelpSupport />} />
        <Route path="setting/helpSupport/faq" element={<Faq />} />
        <Route path="setting/notification" element={<SettingNotification />} />
        <Route path="setting/policies/bookingPolicies" element={<BookingPolices />} />
        <Route path="setting/policies/policiesDelete" element={<CancellationPolicies />} />
        <Route path="setting/policies/reschedulingPolicy" element={<ReschedulingPolicy />} />
        <Route path="setting/policies/refundPolicy" element={<RefundPolicy />} />
        <Route path="setting/my-plan" element={<MyPlan />} />
        <Route path="setting/my-plan/my-plan-history/:selectedTabs/:currency" element={<MyPlanHistory />} />
        <Route path="setting/my-card" element={<MyCard />} />
        <Route path="setting/promotionalAddonPlan" element={<PromotionalAddon />} />
        <Route path="setting/commission-structure" element={<CommissionStructure />} />
        <Route path="setting/commission-structure/add" element={<AddCommissionStructure />} />
        <Route path="setting/commission-structure/update/:id" element={<UpdateCommissionStructure />} />

        <Route path="profile" element={userData?.roleTitle === 'SERVICE_PROVIDER' ? <Profile /> : <ProfileTeam />} />

        {
          userData?.planDetails?.addons?.length && userData?.planDetails?.addons?.find((item) => item.keyName === "insight")?.keyValue ?
            <>
              <Route path="insightList" element={<InsightList />} />
              <Route path="insightList/bookingDetails" element={<BookingDetails />} />
              <Route path="insightList/clientReport" element={<ClientReport />} />
              <Route path="insightList/teamReport" element={<TeamReport />} />
              <Route path="insightList/demoGraphics" element={<DemoGraphics />} />
              <Route path="insightList/serviceReport" element={<ServiceReport />} />
              <Route path="insightList/feedBack" element={<FeedBack />} />
              <Route path="insightList/rushHours" element={<RushHours />} />
              <Route path="insightList/combo-report" element={<ComboReport />} />
              <Route path="insightList/combo-package-report" element={<ComboPacakgeReport />} />
              <Route path="insightList/promotionalMessage" element={<PromotionalMessage />} />
              <Route path="insightList/commission" element={<Commission />} />
              <Route path="insightList/commission/by-structure-details/:STRUCTURE_ID/:groupId" element={<ByStructureDetails />} />
              <Route path="insightList/commission/team-member/history/:STAFF_ID" element={<ByTeamMemberDetails />} />
              <Route path="insightList/commission/group-details/:GROUP_ID" element={<BroupCommissionDetails />} />

            </>
            : null
        }

        {
          userData?.planDetails?.addons?.length && userData.planDetails.addons.find((item) => item.keyName === 'chat')?.keyValue ?
            <>
              <Route path="chat" element={<Chat />} />
              <Route path="chat-mobile" element={<ChatMobile />} />
            </>
            : null
        }
              <Route path="chat-ai" element={<ChatAi />} />

        {/* <Route path="chat" element={<Chat />} /> */}
        {/* <Route path="chat-mobile" element={<ChatMobile />} /> */}
        {/* <Route path="multiple-login/:id" element={<MultipleLogin />} /> */}



        <Route path="*" element={<PageNoFound />} />
      </Routes>
    </div>
  )
}

export default Main
